import { render, staticRenderFns } from "./data-cell.vue?vue&type=template&id=4d2f8c34&scoped=true&"
import script from "./data-cell.vue?vue&type=script&lang=js&"
export * from "./data-cell.vue?vue&type=script&lang=js&"
import style0 from "./data-cell.vue?vue&type=style&index=0&id=4d2f8c34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f8c34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2f8c34')) {
      api.createRecord('4d2f8c34', component.options)
    } else {
      api.reload('4d2f8c34', component.options)
    }
    module.hot.accept("./data-cell.vue?vue&type=template&id=4d2f8c34&scoped=true&", function () {
      api.rerender('4d2f8c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bussiness/home/components/data-cell.vue"
export default component.exports